import axios  from "axios"
import i18n from "@/i18n"
var apiClient = null;
if (process.env.VUE_APP_HOMEPAGE_PROXY === 'true') {
  apiClient = axios.create({

  });

} else {
  apiClient = axios.create({
    baseURL: process.env.VUE_APP_HOMEPAGE_API_BASE_URL,
    withCredentials: true
  });

}

apiClient.interceptors.request.use(request => {
    // const accessToken =  "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzb2xnaXQiLCJhdXRoIjoiIiwiZXhwIjoxNjU0Njg1NzAzLCJpYXQiOjE2NTIwOTM3MDN9.DhD-Jvgkib8srmf0t8M5LUJ4pCRpxiDEld5Iel5WjI9Ev9wJRdVg_mV3QcyjBY8aojKQQ31X42cs8naEm8ZB8g";
    // request.headers.common.Authorization = `Bearer ${accessToken}`;
    request.headers["Accept-Language"] = i18n.global.locale.value;
    return request;
});


export {  apiClient };